import store from '../../store/store';
import geoJSONHelper from '../../helpers/geoJSON';
import colors from '../../helpers/colors'

export default function LandSlide(opts={}){
    BaseConstructor.call(this)
    let {container,map} = opts
    let elements = {}
    let context = this
    
    let featureGroup = new L.featureGroup()
    let features = []

    this.prepareFeatures = () =>{
        let by_city = {}
        store.fluConfig.getStations().map(station=>{
            by_city[station.cod_ibge] = by_city[station.cod_ibge] || []
            by_city[station.cod_ibge].push(station.value)
        })

        features.forEach(feature=>{
            let city = by_city[feature.cod_ibge] || []
            if(city.length > 0){
                let accum = Math.max(...city)
                feature.setStyle(getStyleByAccum(accum,feature))
                // featureGroup.addLayer(feature)
                feature.accum = accum
            } else {
                feature.setStyle(getStyleByAccum(-1,feature))
                // featureGroup.addLayer(feature)
            }
        })
    }

    this.update = () =>{

    }

    this.filter = () =>{
        if(features.length === 0){
            geoJSONHelper.getLimitFeatures('city_limit', {simplified: true}).then(data=>{
                features = data
                features.map(feature=>{
                    feature.on('mouseover', e=>{
                        feature.setStyle({
                            fillColor: 'blue'
                        })
                        store.landslideConfigStore.setOption('tooltipOptions', {show:true, content: buildTooltipContent(feature)})
                    })
                    feature.on('mouseout', e=>{
                        store.landslideConfigStore.setOption('tooltipOptions', {show:false})
                        feature.setStyle(getStyleByAccum(feature.accum >= 0 ? feature.accum : -1,feature))
                    })
                    feature.on('click', e=>{                                                
                        map.fitBounds(feature.getBounds())
                        store.fluConfig.setFilterOptions('city_ibges', [feature.cod_ibge])
                        store.mainConfigStore.setOption('hide_all_markers', false)
                    })
                })
                
                context.filterFeatures()
            })
        } else {
            context.filterFeatures()
        }
    }

    this.filterFeatures = _ =>{
        featureGroup.clearLayers()
        context.prepareFeatures()
        features.forEach(feature=>{
            if(store.landslideConfigStore.getFilterOption('legends')[feature.status]){
                featureGroup.addLayer(feature)
            }
        })
    }

    const getStyleByAccum = (accum,feature) =>{
        let color = getColorByAccum(accum,feature)
        return {
            color:'black',
            fillColor:color,
            fillOpacity: 0.5,
            weight: 1,
            opacity: 0.5
        }
    }

    const getColorByAccum = (accum,feature) =>{
        let city = cities.filter(x=>x.cod_ibge === feature.cod_ibge)[0]
        if(accum >= 0){
            if(city && city.parameters){
                feature.city_id = city.id
                let parameter = city.parameters.filter(x=>x.parameter_type_id == 4)[0]
                if(parameter){
                    let limiar = getLimiares(parameter)
                    feature.limiar = limiar
                    let value = limiar.ppdc || limiar.ipt
                    if(accum < value){
                        feature.status = 'ok'
                        return colors.ok
                    } else {
                        feature.status = 'attention'
                        return colors.moderate
                    } 
                }
                
            } else {
                //tem chuva, mas não a cidade não tem paramêtros
                return 'black'
            }
        } else {
            feature.status = 'no_data'
            return 'gray'
        }
        
        
    }

    const getLimiares = parameter =>{
        let date = moment()
        let key = null
        if(Object.keys(parameter.values).length > 0){ //aqui se espera q cada key seja uma data 
            $.each(parameter.values, (date,value)=>{
                if(moment(date) > key){
                    key = moment(date)
                }
            })
            let value = key ? parameter.values[key.format('YYYY-MM-DD')] : null
            if(value &&  value.limiares){
                return (value.limiares.ppdc ? {ppdc: value.limiares.ppdc} : {ipt: value.limiares.ipt || 80})
            } else {
                return {ipt: 80}
            }
        }
    }

    const buildTooltipContent = feature =>{
        let content = `<div class="flex flex-h-center flex-v-center">${feature.name}</div><div><span class="text-info font-weight-bold">${feature.accum >= 0? "Acc: "+feature.accum.toFixed(1)  + ' mm' : ''}</span></div>`
        if(feature.limiar){
            content += `<div>${feature.limiar.ppdc ? 'PPDC:' : 'IPT:'} ${feature.limiar.ppdc || feature.limiar.ipt} mm</div>`
        }
        return content
    }

    init()

    function init(){
        featureGroup.addTo(map)
        store.landslideConfigStore.subscribe('SET_OPTION', data=>{
            if(data.option === 'active'){
              if(data.value){
                //ativando a camada de landslide
                store.mainConfigStore.setOptions([['hide_all_markers', true], ['show_zeros', true]])

                context.filter()
              } else {
                //desativando a camada de landslide
                featureGroup.clearLayers()

                store.mainConfigStore.setOptions([['hide_all_markers', false], ['show_zeros', false]])

                //resetando os filtros de cidade
                store.fluConfig.setFilterOptions('city_ibges', [])
              }
            }
        })
        store.landslideConfigStore.subscribe('SET_FILTER_OPTION', data=>{
            if(data.option === 'legends'){
                context.filter()
            }
        })

        store.mainConfigStore.subscribe('TYPE_UPDATE', type=>{
            if(type==='flu'){
                //quando flu, desativando a camada de landslide
                store.landslideConfigStore.setOption('active', false)
            }
        })

        store.mainConfigStore.subscribe('PLU_LOAD', type=>{
            //quando for alterado data ou hora
            if(store.landslideConfigStore.getOption('active')){
                context.filter()
            }
        })
    }
}

LandSlide.prototype = Object.create(BaseConstructor.prototype)